<template>
  <div :class="guideShow == 1 && !WeChatOrQQ ? 'home2' : 'home1'">
    <div class="boxcenter">
      <img src="../assets/index1.png" alt="" class="img" />
      <div class="boxcenter-text1">庄稼汉</div>
      <div class="boxcenter-text2" v-if="this.guideShow == 1">版本：{{ versionNumber }}</div>
      <div class="boxcenter-text2" v-if="this.guideShow == 2">版本：{{ versionNumber }}</div>
    </div>

    <div class="anzhuang" @click="download">安装</div>
    <div class="usentroduce">
      <div class="usentroduce-text1">应用介绍</div>
      <div class="usentroduce-text2">
        农业领域领先的标准化服务共享平台。平台致力于为特大型农业公司、合作社、种植户提供大田作物“耕、种、管、收”全程标准化服务。为农机合作社、农服公司提供作业订单服务。实现农业生产订单化，用大数据帮农户解决种地难题。农服共享，从而提高农机使用率。
      </div>
    </div>
    <div class="screenshot">
      <div class="usentroduce-text1">应用截屏</div>
      <div class="screenshot-img">
        <img src="../assets/index3.png" alt="" />
        <img src="../assets/index4.png" alt="" style="margin-left: 10px" />
        <img src="../assets/index5.png" alt="" style="margin-left: 10px" />
        <img src="../assets/index6.png" alt="" style="margin-left: 10px" />
        <img src="../assets/index7.png" alt="" style="margin-left: 10px" />
      </div>
    </div>
    <div class="zhezhao" v-if="guideShow == 1 && !WeChatOrQQ"></div>
    <img src="../assets/jiantou.png" alt="" class="jiantou" v-if="guideShow == 1 && !WeChatOrQQ" />
    <div class="zhezhao-text" v-if="guideShow == 1 && !WeChatOrQQ">
      请使用
      <span>「浏览器」</span>
      打开
    </div>
  </div>
</template>

<script>
import AnnualLoginService from '../services/jaxrs/concrete/app'
export default {
  name: 'download',

  data() {
    return {
      guideShow: 0,
      userAgent: navigator.userAgent.toLowerCase(),
      versionNumber: '4.2.11(build371)',
      url: '',
      WeChatOrQQ: true
    }
  },

  created() {
    this.getdata()
  },
  methods: {
    isIOS() {
      return !!this.userAgent.match(/\(i[^;]+;( U;)? cpu.+mac os x/)
    },
    isAndroid() {
      return this.userAgent.indexOf('android') > -1 || this.userAgent.indexOf('linux') > -1
    },
    isHuaWei() {
      return !!(this.userAgent.indexOf('windows nt') > -1)
    },

    isWeChatOrQQ() {
      const ua = this.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') > -1) {
        // 如果是微信
        return true
      } else if (/mqqbrowser[\S|\s]*qq/.test(ua) || / qq/.test(ua)) {
        // 如果是QQ
        return true
      }
      return false
    },
    download() {
      var browser = {
        versions: (function () {
          var u = navigator.userAgent
          // app = navigator.appVersion
          return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
          }
        })(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      }
      if (this.isWeChatOrQQ(this.userAgent)) {
        if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
          //判断是IOS后跳转到相应的链接
          window.location.href = 'https://apps.apple.com/cn/app/id1456065313'
          this.WeChatOrQQ = true
        } else if (browser.versions.android) {
          //判断是android后跳转到相应的链接
          // window.location.href = this.url
          this.WeChatOrQQ = false
        }
      } else {
        if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
          //判断是IOS后跳转到相应的链接
          window.location.href = 'https://apps.apple.com/cn/app/id1456065313'
          this.WeChatOrQQ = true
        } else if (browser.versions.android) {
          //判断是android后跳转到相应的链接
          window.location.href = this.url
          this.WeChatOrQQ = true
        }
      }
    },
    getdata() {
      if (this.isAndroid(this.userAgent) || this.isHuaWei(this.userAgent)) {
        //直接跳转app下载页面
        AnnualLoginService.AppUpgradeVersion(1, 1).then(response => {
          this.versionNumber = response.versionNumber
          this.url = response.url
        })
        this.guideShow = 1
      } else if (this.isIOS(this.userAgent)) {
        //直接跳转app下载页面
        AnnualLoginService.AppUpgradeVersion(2, 1).then(response => {
          this.versionNumber = response.versionNumber
        })
        this.guideShow = 2
      }
    }
  }
}
</script>
<style scoped lang="less">
.zhezhao {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: #000000;
  opacity: 0.3;
  top: 0px;
}
.jiantou {
  position: absolute;
  top: 0px;
  right: 30px;
  z-index: 3;
}
.zhezhao-text {
  width: 168px;
  height: 40px;
  background: #ffffff;
  opacity: 1;
  border-radius: 4px;
  z-index: 3;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: center;
  position: absolute;
  top: 48px;
  right: 20px;
  line-height: 40px;
  span {
    color: rgba(247, 182, 24, 1);
  }
}
.home {
  height: 100vh;
}
.home2 {
  height: 100vh;
  overflow: hidden;
}
.boxcenter {
  text-align: center;
  .img {
    margin-top: 60px;
    width: 114px;
    height: 114px;
  }
  .boxcenter-text1 {
    // width: 66px;
    height: 30px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #707070;
    opacity: 1;
    line-height: 30px;
    margin-top: 26px;
  }
  .boxcenter-text2 {
    height: 17px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #707070;
    opacity: 1;
    line-height: 17px;
    margin-top: 10px;
  }
}

.anzhuang {
  height: 44px;
  background: #f7b618;
  opacity: 1;
  border-radius: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  margin-top: 60px;
  margin-left: 20px;
  margin-right: 20px;
}
.usentroduce {
  padding: 0px 15px;
  margin-top: 70px;
  .usentroduce-text1 {
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    opacity: 1;
  }
  .usentroduce-text2 {
    height: 89px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    opacity: 1;
    margin-top: 10px;
  }
}
.screenshot {
  padding-left: 15px;
  margin-top: 37px;
  // overflow: hidden;
  .usentroduce-text1 {
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    opacity: 1;
  }
  .screenshot-img {
    display: flex;
    overflow: auto;
    margin-top: 10px;
    margin-bottom: 40px;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    img {
      width: 125px;
      height: 222px;
    }
  }
}
</style>
